export default class SearchForm {
    /**
     * SearchForm Constructor.
     * @param {HTMLElement} form
     */
    constructor( form ) {
        if ( !form ) {
            return;
        }

        this.open = false;
        this.form = form;
        this.field = form.querySelector( '[type="search"]' );
        this.toggle = form.querySelector( '[aria-expanded]' );
        this.submitButton = form.querySelector( '[type="submit"]' );
        this.parent = form.parentNode.parentNode;

        this.classNames = {
            inactive: 'search-form--inactive',
            focus: 'search-form--focus',
            parentActive: 'search-active'
        }

        this.events();
    }

    /**
     * All events linked with the searchForm.
     */
    events() {
        this.field.onfocus = () => this.form.classList.add( this.classNames.focus );
        this.field.onblur = () => this.form.classList.remove( this.classNames.focus );

        this.toggle.onclick = ( e ) => {
            e.preventDefault();
            this.toggleSearch();
        }

        /* The setFocusOnToggle is introduced due to the difference keydown and keyup data.
        * Somehow the self.toggle.focus() did not work on keydown.
        * The document.activeElement is on the keyup already on the next element.
         */
        let setFocusOnToggle = false;
        const self = this;
        window.addEventListener( "keydown", ( e ) => {
            if ( !!this.open && (( !!e.shiftKey && 'Tab' === e.key ) || 'Escape' === e.key ) && self.field === document.activeElement ) {
                self.closeSearch();
                setFocusOnToggle = true;
            }
        } );

        window.addEventListener( "keyup", () => {
            if ( !!setFocusOnToggle ) {
                self.toggle.focus();
                setFocusOnToggle = false;
            }
        } );
    }

    /**
     * Toggle the SearchFrom status.
     */
    toggleSearch() {
        this.open = !this.open;
        if ( !!this.open ) {
            this.openSearch();
        } else {
            this.closeSearch();
        }
    }

    /**
     * Force te searchForm to open.
     */
    openSearch() {
        this.open = true;
        this.form.classList.remove( this.classNames.inactive );
        this.parent.classList.add( this.classNames.parentActive );
        this.submitButton.tabIndex = 0;
        this.toggle.setAttribute( 'aria-expanded', true );
        this.field.tabIndex = 0;
        this.field.focus();
    }

    /**
     * Force te searchForm to close.
     */
    closeSearch() {
        this.open = false;
        this.form.classList.add( this.classNames.inactive );
        this.form.classList.remove( this.classNames.focus );
        this.field.tabIndex = -1;
        this.parent.classList.remove( this.classNames.parentActive );
        this.submitButton.tabIndex = -1;
        this.toggle.setAttribute( 'aria-expanded', false );
    }
}
